import React, {Component} from 'react'
import { connect } from 'react-redux'
import { addonAddEditInside, saveInsideAddon } from './../../actions/index.js'

class BuilderAddonsList extends Component {

  constructor(props){
    super(props);

    var addonsList = [];
    for(var key in addonsJSON){
      if (key == 'accordion' || key == 'tab' || key == 'sp_carouselpro' || key == 'carouselpro') {
        continue;
      }
      addonsList.push(addonsJSON[key]);
    }

    this.state = {
      open: false,
      addons : addonsList
    }
  }

  onClickAddon() {
    const { open } = this.state
    this.setState({
      open: !open
    })
  }

  openAddonForm( addonName ) {
    var values = addonsJSON[addonName].default

    var inputName = this.props.inputName;
    var riFieldName = inputName.substring(inputName.indexOf('.')+1);

    this.setState({ open : false })
    
    this.props.saveInsideAddon( values, {
      addonIndex: '',
      addonName: addonName,
      fieldName: this.props.state.sppbForm.activeField.fieldName,
      rfieldIndex: this.props.state.sppbForm.activeField.rfieldIndex,
      riFieldName: riFieldName,
    } )
  }

  render(){
    let listClass = 'inside-addon-list clearfix';
    if (this.state.open) {
      listClass += ' disable'
    }

    return(
      <div className="sppb-addon-list-wrap">
        <div style={{textAlign: 'center'}}>
          <button
            className="sppb-add-inside-addon-btn"
            onClick={(e)=>{
              e.preventDefault();
              this.onClickAddon();
            }}
          ><i className="fa fa-plus" /></button>
        </div>
        <div className = { listClass }>
          <ul className="clearfix">
            {
              this.state.addons.map((addon,index) =>
                <li
                  key={index}
                  onClick={(e)=>{
                    e.preventDefault();
                    var addonName = addon.addon_name.replace('sp_','');
                    this.openAddonForm(addonName)
                  }}
                >
                    <span>
                      <img src={addon.icon} alt={addon.title} />
                      <span>{addon.title}</span>
                    </span>
                </li>
              )
            }
          </ul>
        </div>
      </div>
    )
  }
}


const mapStateToProps = (state) => {
  return {
    state
  }
}


const mapDispatchToProps = ( dispatch ) => {
  return {
    saveInsideAddon: (values,fieldData) => {
      dispatch( saveInsideAddon(values,fieldData) )
    },
    addonAddEditInside: ( addonName, values, riFieldName, addonIndex ) => {
      dispatch( addonAddEditInside( addonName, values, riFieldName, addonIndex ) )
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BuilderAddonsList);



// WEBPACK FOOTER //
// ./src/helpers/form/types/builder-helper/BuilderAddonsList.js